import Swiper from "swiper";
import { Autoplay } from 'swiper/modules';
import "swiper/css";
import "./client-logos.css";

window.addEventListener("DOMContentLoaded", () => {
	new Swiper(".des-client-logos", {
		modules: [Autoplay],
		autoplay: { delay: 2000 },
		loop: true,
		slidesPerView: 3,
		speed: 600,
		breakpoints: {
			480: {
				slidesPerView: 4,
			},
			768: {
				slidesPerView: 7,
			}
		}
	});
});
